module.exports = __webpack_public_path__ + "media/images/expert__dani-kern-3cb15204b762189cf95843d802aa22f3.png";